import Backbone from 'backbone'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import _ from 'lodash'
import numericRangeValidatorFactory from 'scoreboard/components/validators/numeric-range-validator-factory'

function parseValue(opts, val) {
	if (opts.floating) {
		var v = parseFloat(val)
		return _.isFinite(v) ? v : null
	} else {
		return _.parseInt(val,10)
	}
}

/**
 * Base Backbone.View for numeric filters (used in reports and datasets)
 */
var NumericFilter = Backbone.View.extend({

	className: 'numeric-filter',

	events: {
		'change select[name=operator]': '_applyOperator'
	},

	initialize: function(options) {
		this.options = options || {}
		this.data = _.defaults({}, this.options.data)
		this.data.value1 = isNaN(this.data.value1) ? '' : this.data.value1
		this.data.value2 = isNaN(this.data.value2) ? '' : this.data.value2
		this.validators = [numericValidator]
		if (!this.options.allowIncomplete) {
			this.validators.splice(0, 0, requiredValidator)
		}
		if (_.isFinite(this.options.min) && _.isFinite(this.options.max) &&
			this.options.min <= this.options.max) {
			this.validators.push(numericRangeValidatorFactory(this.options.min,
				this.options.max))
		}
	},

	// call this in subclasses after the main template has been rendered
	finishRendering: function() {
		//toggle display of second input for "between" filters
		this._applyOperator()

		return this
	},

	// returns the value of the operator type dropdown
	_val: function() {
		return this.$('select[name=operator]').val()
	},

	_isBetween: function() {
		return this._val() == 'between-number'
	},

	//toggles display of extra input depending on operator selection
	_applyOperator: function() {
		let isBetween = this._isBetween()
		this.$('.between-number')
			.toggleClass('is-not-displayed', !isBetween)
			.toggleClass('is-between-number', isBetween)
		this.$('.text-wrapper').toggleClass('between-filter', isBetween)
	},

	//returns the data captured by this filter
	gather: function() {
		var op = this.$('select[name=operator]').val()
		this.data.operator = op
		//use the value from the marked-field as that handles the localization of the string
		this.data.value1 = op == 'is-blank' ? null : parseValue(this.options, this.valueOrEquation1.markedField.val())
		this.data.value2 = op == 'between-number' ? parseValue(this.options, this.valueOrEquation2.markedField.val()) : null
		return this.data
	}

})

export default NumericFilter

NumericFilter.__filename__ = 'components/numeric-filter.js'
